import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
export function toggleValueInArray(value) {
  var arr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return arr.includes(value) ? arr.filter(function (v) {
    return v !== value;
  }) : [].concat(_toConsumableArray(arr), [value]);
}